import React, { useEffect, useState, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { useTheme } from '../../../hooks/theme';

import api from '../../../services/api';

import { CurrencyCircleDollar, Exam, House, SmileyWink, Student, UserCircle, YoutubeLogo } from 'phosphor-react';

import LoaderBIO from '../../../components/Loader';
import Breadcrumbs from '../../../components/Breadcrumbs';

import { Container, ContentGrid2 } from './styles';

interface ISuportProps {
  id: string;
  name: string;
  description: string;
  slug: string;
  icon: string;
  position: number;
}

interface IIconsProps {
  [key: string]: ReactNode;
}

const SuporteTecnico: React.FC = () => {
  const { theme } = useTheme();
  const [loading, setLoading] = useState(true);
  const [suporteCategories, setSuportCategories] = useState<ISuportProps[]>([]);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const response = await api.get('/sections');

        console.log('LIST SUPORT CATEGORIES >>>>>>>>>>>>>>>>>>>');
        console.log(response.data);

        setSuportCategories(response.data);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const iconColor = theme === 'dark' ? '#03bb85' : '#aa14cb';

  const icons: IIconsProps = {
    'coins': <CurrencyCircleDollar size={48} weight="duotone" color={iconColor} />,
    'user': <UserCircle size={48} weight="duotone" color={iconColor} />,
    'video': <YoutubeLogo size={48} weight="duotone" color={iconColor} />,
    'styudy-plans': <Student size={48} weight="duotone" color={iconColor} />,
    'exams': <Exam size={48} weight="duotone" color={iconColor} />,
    'outher': <SmileyWink size={48} weight="duotone" color={iconColor} />,
  }

  return (
    <Container>
      <Breadcrumbs
        icon={House}
        separator="/"
        padding="1rem 0"
        route={[
          { title: 'Central de ajuda', link: '/suporte' },
        ]}
      />
      <ContentGrid2>
        {suporteCategories.map((category, index) => (
          <Link to={`/suporte/artigos/${category.slug}`} key={index}>
            {icons[category.icon]}
            <h1>{category.name}</h1>
            <p>Clique para visualizar os artigos desta seção</p>
          </Link>
        ))}
        <LoaderBIO isVisible={loading} />
      </ContentGrid2>
    </Container>
  );
}

export default SuporteTecnico;
